export enum ProgressIndicatorType {
  DETERMINATE = 'determinate',
  INDETERMINATE = 'indeterminate',
  BUFFER = 'buffer',
  QUERY = 'query'
}
